export const modes = {
  BIKE: "le vélo",
  PUBTRANS: "les transports en commun",
  COVOIT: "le covoiturage",
  EBIKE: "le vélo à assistance électrique",
  CAR: "la voiture",
};
